export enum MeterConfig {
  basic = 'no-smart-no-solar',
  smart = 'smart-no-solar',
  solar = 'no-smart-solar',
  smartAndSolar = 'smart-solar',
}
